// Renders a flag emoji for every [data-flag-for="XX"] element found on the
// page, where XX is a 2-letter ISO 3166-1 country code. Works generically for
// any country Shopify Markets is configured with — no per-country hardcoding.
function isoCodeToFlagEmoji(isoCode) {
  if (!isoCode || isoCode.length !== 2) return '';
  const codePoints = isoCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

function renderCountryFlags(root = document) {
  root.querySelectorAll('[data-flag-for]').forEach((el) => {
    if (el.dataset.flagRendered) return;
    const flag = isoCodeToFlagEmoji(el.dataset.flagFor);
    if (flag) {
      el.textContent = flag;
      el.dataset.flagRendered = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => renderCountryFlags());

// Re-run when the theme editor re-renders a section (e.g. header settings change)
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => renderCountryFlags(event.target));
}
